/**
 * Created by jonas on 2020-03-18.
 */
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { SlideShowPage } from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import { ImgLoader } from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility,
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import * as PIXI from "pixi.js";

import { DDD } from "../DDD";

export class DDDIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.4,
            bulletColor: 0xffffff,
        },
        stampColor: 0xffffff,
    };

    stampConfig: StampConfig = {
        xWays: false,
        xBet: true,
        xNudge: true,
        xGod: true,
        volatility: Volatility.EXTREME,
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[] = [];

    constructor() {}

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(`introBg`, `resources/images/DDD/Intro_BG.png`);
        imgLoader.add(`introDiv`, `resources/images/DDD/Intro_Divider.png`);
        imgLoader.add(`page1`, `resources/images/DDD/page1.png`);
        imgLoader.add(`page2`, `resources/images/DDD/page2.png`);
        imgLoader.add(`page3`, `resources/images/DDD/page3.png`);
        imgLoader.add(`page4`, `resources/images/DDD/page4.png`);
        imgLoader.add(`maxWinAmount`, `resources/images/DDD/maxWinAmount.png`);

        return imgLoader.load().then(() => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        this.background.name = `IntroBackground`;
        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introBg`));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderTop.name = `IntroBorderTop`;
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introDiv`));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        this.borderBottom.name = `IntroBorderBottom`;
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`introDiv`));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();

        const numPages: number = 3;
        let page: SlideShowPage;
        for (let count: number = 1; count <= numPages; count++) {
            page = new SlideShowPage(ImgLoader.getImgTexture(`page` + count));
            (page.children[0] as PIXI.Sprite).anchor.set(0.46, 0.5);
            this.pages.push(page);
        }

        if (DDD.apiPlugin.gameClientConfiguration.isSet) {
            this.handleConditionalPages();
        } else {
            DDD.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.handleConditionalPages();
            });
        }
    }

    private handleConditionalPages(): void {
        if (!DDD.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
            this.addWinCapPage();
        }
    }

    private addWinCapPage(): void {
        const textureName: string = `page4`;
        const maxCapPage: SlideShowPage = new SlideShowPage(),
            winCapImage: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(textureName));

        winCapImage.anchor.set(0.5);
        maxCapPage.addChild(winCapImage);
        this.pages.push(maxCapPage);

        const maxImg: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(`maxWinAmount`));
        maxImg.name = `winAmount`;
        maxImg.anchor.set(0.5, 0.5);
        maxImg.position.set(0, 106);

        winCapImage.addChild(maxImg);
    }
}
